import {MAX_PROGRESS_RATE} from '../constant/viewerConstant';

export function convertToLastViewRate({
  position,
  total,
  isTwoPageLayout,
}: {
  position: number;
  total: number;
  /**
   * "두쪽보기 설정 후 총페이지 수가 짝수일 때" 마지막페이지 노출시 현재페이지는 총페이지수 - 1 인 케이스를 처리합니다.
   * 마지막 페이지가 노출 됐는데도 rate가 10000이 되지 않는 문제가 있어 해당 케이스를 처리하기 위한 파라미터입니다.
   */
  isTwoPageLayout?: boolean;
}) {
  const _position =
    isTwoPageLayout && total % 2 === 0 ? position + 1 : position;

  // 전체가 없거나 0인 경우 모두 다 읽은걸로 간주하고 max rate를 리턴합니다
  if (total === undefined || total === 0) {
    return MAX_PROGRESS_RATE;
  }

  // 일어날 일 없지만 혹시나 NaN 가 들어와도 사용자에게 에러화면을 보여줄 필요는 없으니 에러가 아니라 0을 리턴합니다. 단, 예외적인 상황이니 로그는 남깁니다.
  if (isNaN(_position) || isNaN(total)) {
    // TODO: 잘못된 인자 에러 전송
    return 0;
  }

  // 부분이 없거나 처음인 경우 무조건 0을 리턴합니다
  if (!_position || _position < 0) {
    return 0;
  }
  const result = Math.floor((_position / total) * MAX_PROGRESS_RATE);
  return result > MAX_PROGRESS_RATE ? MAX_PROGRESS_RATE : result;
}
